export type HorizontalAlignType =
  | "image-align-x-left"
  | "image-align-x-right"
  | "image-align-x-center";
export type ImageLayoutType =
  | "image-layout-landscape"
  | "image-layout-portrait"
  | "image-layout-portrait-small"
  | "image-layout-landscape-small"
  | "image-layout-portrait-full-width"
  | "image-layout-landscape-full-width";

export const getImageHorizontalAligment = (styles: string[]) => {
  return styles.filter((style) =>
    style.includes("image-align-x"),
  ) as HorizontalAlignType[];
};

export const getImageLayout = (styles: string[]) => {
  return styles.filter((style) =>
    style.includes("image-layout"),
  ) as ImageLayoutType[];
};

export const isLayoutFullWidth = (styles: string[]) => {
  return styles.some((style) => style.includes("full-width"));
};
